import React from 'react';

import { View } from 'react-native';

import Animated, {
    SharedValue,
    useAnimatedStyle,
} from 'react-native-reanimated';

import { ContentType } from 'services/data-manager/types';

import RibbonTouchable from 'components/CustomButtons/RibbonTouchable';
import { TileTitle } from 'components/Ribbon/components/TileTitle';

import styles from './styles';

type Props = {
    railId: string;
    contentType: ContentType;
    opacitySharedValue: SharedValue<number>;
};

const LOADING_CARDS = [...Array(7).keys()];

function StripeSkeletonLoading({
    opacitySharedValue,
    railId,
    contentType,
}: Props) {
    const animatedStyle = useAnimatedStyle(() => ({
        opacity: opacitySharedValue.value,
    }));

    return (
        <Animated.View style={[styles.root, animatedStyle]}>
            {LOADING_CARDS.map((n) => (
                <RibbonTouchable
                    key={`loading-card-${railId}-${n}`}
                    metadataType={contentType}
                    disabled
                    style={styles.card}
                    RibbonInfoComponent={
                        contentType === ContentType.ChannelItem ? undefined : (
                            <View style={styles.cardTitleContainer}>
                                <TileTitle loading />
                            </View>
                        )
                    }
                />
            ))}
        </Animated.View>
    );
}

export default React.memo(StripeSkeletonLoading);
